module.exports = __webpack_public_path__ + "img/headway-capital-credit-for-small-businesses-black.25ac2df9.png";